import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import { PrismIcon } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import type {
  Category,
  SubCategory,
} from 'lumen/utils/constants/transaction-mapping/constants';
import {
  CATEGORY_TRANSLATIONS,
  SUB_CATEGORY_TRANSLATIONS,
} from 'lumen/utils/constants/transaction-mapping/translation-constants';

interface SettingsTransactionMappingCellsTdOurCategorySignature {
  Args: {
    displayValue?: {
      category: Category;
      subCategory: SubCategory;
    };
    rowMeta?: {
      isSelected: boolean;
    };
  };
}

export default class SettingsTransactionMappingCellsTdOurCategory extends Component<SettingsTransactionMappingCellsTdOurCategorySignature> {
  @service declare intl: Services['intl'];

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get isMixed() {
    return !this.args.displayValue;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get isRowSelected() {
    return this.args.rowMeta?.isSelected;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get isUnmapped() {
    return (
      this.args.displayValue &&
      this.args.displayValue.category === 'unmapped' &&
      this.args.displayValue.subCategory === 'unmapped'
    );
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get translatedCategory() {
    const category = this.args.displayValue?.category;

    if (!category) {
      return '';
    }

    return this.intl.t(CATEGORY_TRANSLATIONS[category]);
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get translatedSubCategory() {
    const subCategory = this.args.displayValue?.subCategory;

    if (!subCategory) {
      return '';
    }

    return this.intl.t(SUB_CATEGORY_TRANSLATIONS[subCategory]);
  }

  <template>
    <div class="flex items-center gap-100" data-test-id="td-our-category">
      {{#if this.isMixed}}
        {{t "settings.transaction_mapping.mixed"}}
      {{else if this.isUnmapped}}
        <PrismIcon
          @color={{unless this.isRowSelected "on-warning"}}
          @name="connection"
        />
        <span
          class={{if
            this.isRowSelected
            "text-neutral-default"
            "text-warning-emphasis"
          }}
        >
          {{t "general.unmapped"}}
        </span>
      {{else}}
        <span class="text-neutral-subdued">{{this.translatedCategory}}</span>
        <PrismIcon @name="chevron-right" @size="small" />
        <span class="text-neutral-default">{{this.translatedSubCategory}}</span>
      {{/if}}
    </div>
  </template>
}
